export const CoreDataSecurityApplicationsByIdName = 'CoreDataSecurityApplicationsById';
